import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";
import { CollapsibleBanner } from "src/components/CollapsibleBanner";
import { ROLE_FIELD } from "../constants/fields";
import { StepControls } from "../StepControls";
import { StepControlsProps } from "../types";
import { registrationDescriptionsTrns, registrationTitlesTrns } from "../trns";
// import { Roles } from "src/@types/users";
// import { useFormikContext } from "formik";
// import { IRegisterValues } from "src/@types/auth";

// const textKeys = {
//   [Roles.OWNER]: registrationDescriptionsTrns.registeringAsOwner,
//   [Roles.AGENT]: registrationDescriptionsTrns.registeringAsBroker,
// };

interface Props extends StepControlsProps {}

export const RegisteringAs: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();
  // const { values } = useFormikContext<IRegisterValues>();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.youRegisteringAs)}
        </h2>

        <div className="flex-1">
          <RenderFormFields fields={ROLE_FIELD} />
          <br />
          <div className="flex flex-col md:flex-row gap-4 items-start">
            <CollapsibleBanner>
              {t(registrationDescriptionsTrns.registeringAsOwner)}
            </CollapsibleBanner>
            <CollapsibleBanner>
              {t(registrationDescriptionsTrns.registeringAsBroker)}
            </CollapsibleBanner>

            {/* <CollapsibleBanner>{t(textKeys[values.role])}</CollapsibleBanner> */}
          </div>
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
